import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaTimes } from 'react-icons/fa';

const TransportModal = ({ isOpen, onClose }) => {
  const transportOptions = [
    {
      title: "Traslado Interno Jesus María",
      description: "Servicio de traslado desde alojamientos cercanos al Nawan Resort",
      whatsappMessage: "Hola! Me gustaría reservar el traslado desde alojamientos cercanos al Nawan Resort"
    },
    {
      title: "Traslado Córdoba - Nawan Resort (Regreso 5am)",
      description: "Traslado desde Córdoba Capital a Jesus María, con regreso al finalizar la fiesta (aproximadamente 5am)",
      whatsappMessage: "Hola! Me gustaría reservar el traslado desde Córdoba a Nawan Resort con regreso a las 5am"
    }
  ];

  return (
    <AnimatePresence>
      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50">
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.95 }}
            className="bg-white rounded-2xl p-6 max-w-lg w-full max-h-[90vh] overflow-y-auto relative"
          >
            <button
              onClick={onClose}
              className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
            >
              <FaTimes />
            </button>

            <h3 className="text-2xl font-cursive text-[#D4AF37] mb-6 text-center">
              Opciones de Transporte
            </h3>
            <p className="text-gray-600 mb-4 text-center text-xs italic">(sin costos adicionales)</p>

            <div className="space-y-6">
              {transportOptions.map((option, index) => (
                <div key={index} className="border rounded-lg p-4 hover:shadow-md transition-shadow">
                  <h4 className="text-xl font-serif text-gray-800 mb-2">{option.title}</h4>
                  <p className="text-gray-600 mb-4">{option.description}</p>
                  <a
                    href={`https://wa.me/+543518119413?text=${encodeURIComponent(option.whatsappMessage)}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block bg-[#D4AF37] hover:bg-[#B4941F] text-white font-serif py-2 px-6 rounded-full transition-colors duration-300"
                  >
                    Reservar esta opción
                  </a>
                </div>
              ))}
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

export default TransportModal; 